const invitingHiders = [].slice.call(
    document.querySelectorAll("[data-inviting-hider]")
);
const invitingEl = document.querySelector("[data-inviting]");

if ("IntersectionObserver" in window) {
    let dynamicInvitingObserver = new IntersectionObserver(
        (entries, _observer) => {
            const isIntersecting = !!entries.find((entry) => entry.isIntersecting)

            if (isIntersecting) {
                if (invitingEl) invitingEl.dataset.inviting = "hidden";
            } else {
                if (invitingEl) invitingEl.dataset.inviting = "showed";
            }
        }
    );

    invitingHiders.forEach(function (hider) {
        dynamicInvitingObserver.observe(hider);
    });
}
